import React from 'react';
import { CheckCircle } from 'lucide-react';

const ModelsSection = ({ brandName, models }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2B3990] mb-4">
              Modelos de {brandName} Atendidos
            </h2>
            <p className="text-gray-600">
              Trabalhamos com todos os modelos de {brandName}. Confira alguns dos mais atendidos:
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {models.map((model, index) => (
              <div 
                key={index}
                className="flex items-center gap-2 p-4 bg-white rounded-lg shadow-sm"
              >
                <CheckCircle size={20} className="text-[#8DC63F] flex-shrink-0" />
                <span className="text-gray-700 font-medium">{model}</span>
              </div>
            ))}
          </div>

          <p className="text-center text-gray-500 mt-8">
            Não encontrou seu modelo? Entre em contato que atendemos todos os modelos de {brandName}!
          </p>
        </div>
      </div>
    </section>
  );
};

export default ModelsSection;